module.exports = __webpack_public_path__ + "img/ubbbrrru_cursor_pointer_small.59151217.png";